import { AdaptiveFilterButtons } from '@/features/adaptiveFilterButtons/AdaptiveFilterButtons'
import { FilterButtonModel } from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { SearchInput } from '@/shared/components/SearchInput/SearchInput'

type Props = {
  selectedIndex: number
  selectFilterBtn: (index: number) => void
  setQuery: (value: string) => void
}

export const DealsInputsBlock = ({ setQuery, selectFilterBtn, selectedIndex }: Props) => {
  const filterButtons: FilterButtonModel[] = [
    { name: 'Все', label: 'all', index: 1 }, // TopupTraderStatus.All
    { name: 'В ожидании оплаты', label: 'inProgress', index: 2 }, // TopupTraderStatus.WaitingPayment
    { name: 'Завершены', label: 'done', index: 3 }, // TopupTraderStatus.Paid
    { name: 'Отменены', label: 'canceled', index: 4 }, // TopupTraderStatus.Cancelled
    { name: 'Споры', label: 'disput', index: 5 }, // TopupTraderStatus.Disput
  ]

  return (
    <div className="flex justify-between gap-4 mb-6 md:mb-[40px]">
      <AdaptiveFilterButtons
        selectedBtn={selectedIndex}
        setSelectedBtn={selectFilterBtn}
        filterButtons={filterButtons}
        minWidthMobile="150px"
        className="flex-1"
      />
      <SearchInput
        onChange={(event) => {
          const numericOnly = event.target.value
          setQuery(numericOnly)
        }}
        placeholder="Поиск"
        minWidth="150px"
        className="flex-1"
      />
    </div>
  )
}
